<template>
  <div>
    <ModalCover @closeModal="$emit('closeTriggered')" modal_style="modal-md-lg">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body" class="modal-wrapper brand_navy_bg">
        <div class="title-row">
          <div class="text font-weight-600 color_white">
            Summer School Overview
          </div>
        </div>

        <!-- CONTENT BODY  -->
        <div class="content-body">
          <div class="course-title-text text-center border_grey">
            Interest-led classes your children will love!
          </div>

          <div class="content-row">
            <!-- CODING  -->
            <div class="content-card">
              <img v-lazy="localImg('heroCoding.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Coding</div>
                <div class="rule"></div>
                <div class="description">
                  During these classes, your child will improve their logical
                  thinking, creative thinking, and
                </div>

                <a
                  href="https://summer.gradely.ng/course/coding"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>

            <!-- Visual  -->
            <div class="content-card">
              <img v-lazy="localImg('heroVisual.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Visual Design</div>
                <div class="rule"></div>
                <div class="description">
                  Help your child release their creativity while building
                  valuable communication skill for the
                </div>

                <a
                  href="https://summer.gradely.ng/course/visual-design"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>

            <!-- Culinary  -->
            <div class="content-card">
              <img v-lazy="localImg('heroCulinary.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Culinary</div>
                <div class="rule"></div>
                <div class="description">
                  This is for the enthusiastic food lovers that would like to
                  engage their 5 senses. At the
                </div>

                <a
                  href="https://summer.gradely.ng/course/culinary"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>

            <!-- Dance  -->
            <div class="content-card">
              <img v-lazy="localImg('heroDance.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Dance</div>
                <div class="rule"></div>
                <div class="description">
                  Your active and vibrant child will learn fun and enthralling
                  dance styles that will come
                </div>

                <a
                  href="https://summer.gradely.ng/course/dance"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>

            <!-- Entrepreneurship -->
            <div class="content-card">
              <img v-lazy="localImg('heroEntrepreneur.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Entrepreneurship</div>
                <div class="rule"></div>
                <div class="description">
                  For the creative problem solvers, this 5 week course will help
                  your child understand
                </div>

                <a
                  href="https://summer.gradely.ng/course/entrepreneurship"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>

            <!-- Video -->
            <div class="content-card">
              <img v-lazy="localImg('heroVideo.png')" alt="" />
              <div class="img-overlay"></div>

              <div
                class="course-details my-auto index-1 text-center white-text"
              >
                <div class="course-name">Video Production</div>
                <div class="rule"></div>
                <div class="description">
                  Your child will learn to produce, create, and edit videos they
                  can use for video adverts
                </div>

                <a
                  href="https://summer.gradely.ng/course/video-production"
                  class="btn-link text-center d-block"
                  >Course Info</a
                >
              </div>
            </div>
          </div>

          <div
            class="title-text text-center font-weight-600 brand_accent"
            v-if="false"
          >
            Keep your child active and watch them grow.
          </div>

          <div class="description border_grey text-center mx-auto">
            Replace mindless videogaming and long boring hours with curiosity
            and creativity this summer. Engage your children's interests with
            minimal demand of your time.
            <a href="https://gradely.ng/summer" class="btn-link">Learn More</a>
          </div>

          <button class="btn btn-accent mx-auto" @click="getStarted">
            Get Started
          </button>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "SummerSchoolModal",

  components: {
    ModalCover,
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },

  methods: {
    getStarted() {
      if (this.account_type === "parent")
        this.$router.push({
          name: "SummerSchoolConnectChildOnboarding",
        });
      else
        this.$router.push({
          name: "SummerSchoolConnectChildOnboardingStudent",
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .title-row {
    padding: 25px 15px 0;
    margin-bottom: 10px;

    .text {
      font-size: 15.75px;
    }
  }

  .content-body {
    min-height: 30vh;
    height: auto;
    max-height: 75vh;
    overflow: auto;
    padding: 0 15px 15px;

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgba($border_grey_dark, 0.7);
    }

    .title-text {
      font-size: 16.5px;
      line-height: 22px;
      margin-bottom: 8px;
    }

    .description {
      font-size: 13.5px;
      line-height: 24px;
      width: 85%;
    }

    .btn {
      margin-top: 15px;
      font-size: 11.5px;
      padding: 11px 32px !important;
    }

    .course-title-text {
      margin-top: 8px;
      font-size: 13px;
      font-weight: 600;
    }

    .content-row {
      @include flex_row_between_wrap;
      margin-top: 10px;

      .content-card {
        position: relative;
        overflow: hidden;
        border-radius: 5px;
        width: 32%;
        min-height: 180px;
        height: auto;
        padding: toRem(20);
        @include flex_column_center;
        margin-bottom: 10px;

        img {
          @include img_cover;
        }

        .img-overlay {
          position: absolute;
          @include section_stretch;
          background: rgba(0, 0, 0, 0.7);
        }

        .course-details {
          @include flex_column_center;

          .course-name {
            font-size: 14px;
            line-height: 19px;
            font-weight: 600;
          }

          .rule {
            height: 2px;
            width: 50px;
            background: $brand_accent;
            margin: 12px auto 10px;
          }

          .description {
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 5px;
          }

          a {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
